"use client";

import { useRouter } from "next/navigation";
import { useTranslation } from "react-i18next";
import { Button, Heading, Text, Link, ImageWrapper } from "ui-components";

export default function NotFound(): JSX.Element {
  const { t } = useTranslation("not-found");
  const router = useRouter();

  return (
    <div className="flex flex-col justify-center items-center gap-5 my-10">
      <Heading className="text-center px-5">
        {t("sorry_we_could_not_find_that_org")}
      </Heading>
      <div>
        <Text>{t("org_not_found_message")}&nbsp;</Text>
        <Link href="/organizations">{t("browse_orgs_directory")}</Link>
      </div>
      <Button onClick={() => router.push("/organizations")}>
        {t("browse_organisations")}
      </Button>
      <ImageWrapper
        src="/not-found.png"
        width={555}
        height={500}
        alt="Picture of the author"
      />
    </div>
  );
}
